import { useLayoutEffect } from 'react'
// ?inline → string CSS já processada (resolve @import do legado em ../../projeto).
import legadoCss from '@/styles/app-legado.css?inline'

const STYLE_ID = 'hi-legado-visual'
const THEME_KEY = 'hi-theme' // mesma chave do projeto/index.html

let refs = 0

export type Theme = 'light' | 'dark'

export function getStoredTheme(): Theme {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

export function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch {
    /* storage indisponível */
  }
}

/**
 * Injeta o CSS do legado enquanto a rota autenticada/login está montada
 * e aplica o tema salvo (`hi-theme`). Ao sair (ex.: /carreiras) remove tudo
 * e volta para tema claro.
 */
export function useLegadoVisual() {
  useLayoutEffect(() => {
    refs += 1
    let el = document.getElementById(STYLE_ID) as HTMLStyleElement | null
    if (!el) {
      el = document.createElement('style')
      el.id = STYLE_ID
      el.textContent = legadoCss
      document.head.appendChild(el)
    }
    document.documentElement.setAttribute('data-theme', getStoredTheme())
    document.body.classList.add('hi-legado')

    return () => {
      refs -= 1
      if (refs <= 0) {
        refs = 0
        document.getElementById(STYLE_ID)?.remove()
        document.documentElement.setAttribute('data-theme', 'light')
        document.body.classList.remove('hi-legado')
      }
    }
  }, [])
}
